import React from 'react';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';
import IEntityTag from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/EntityTag';

type TagChipsListProps = {
  tags: IEntityTag[];
};

const FlowModelSummaryTag = ({ tags }: TagChipsListProps) => {
  return (
    <div className="flow-model-summary-tag">
      {tags.map((tag) => (
        <Chip key={tag.id} name={tag.name} color={tag.color} />
      ))}
    </div>
  );
};

export default FlowModelSummaryTag;
